$(document).ready(function () {
  $(document).on('click', '.header__icon--cart.header__icon--cart--target-desktop', function(e) {
    e.preventDefault();
    
      window.Rebuy.SmartCart.show();
    
  });
  $(document).on('click', '.header__icon--cart--target-mobile', function(e) {
    e.preventDefault();
    
      window.Rebuy.SmartCart.show();
    
  });

  document.addEventListener('rebuy:cart.change', (event) => { 
    $(".header__icons").load(" .header__icons"); 
  });

  $(".s-qstn .q-title, .s-qstn .symbol").click(function (e) { 
    e.preventDefault();
    $(this).parents(".s-qstn").find(".ans").slideToggle();
    $(this).parents(".s-qstn").find(".plus").toggle();
    $(this).parents(".s-qstn").find(".minus").toggle();
    $(this).toggleClass("active");
  });
  $(".hover-search").click(function(e){
    e.preventDefault();
    if($(this).hasClass("hover-content-show")){
      $(this).removeClass("hover-content-show");
      $(this).parents(".hs-p").siblings(".QuickLearnTooltip").css("opacity", "0");
      $(this).parents(".hs-p").siblings(".QuickLearnTooltip").css("visibility", "hidden");
    }else{
      $(this).addClass("hover-content-show");
      $(this).parents(".hs-p").siblings(".QuickLearnTooltip").css("opacity", "1");
      $(this).parents(".hs-p").siblings(".QuickLearnTooltip").css("visibility", "initial");
    }
  });
  $(".hover-search").hover(function (e) {
    // over
    e.preventDefault();
    $(this).parents(".hs-p").siblings(".QuickLearnTooltip").css("opacity", "1");
    $(this).parents(".hs-p").siblings(".QuickLearnTooltip").css("visibility", "initial");
    
  }, function (e) {
    // out
    e.preventDefault();
    $(this).parents(".hs-p").siblings(".QuickLearnTooltip").css("opacity", "0");
    $(this).parents(".hs-p").siblings(".QuickLearnTooltip").css("visibility", "hidden");
  });

  let articles = $('.PRS .product-review');
  let groupNum = 0;
  let totalNum = 0;
  let currentGroupNum = 0;
  let totalBlocks = 0;
  $.each(articles, function(index, value) {
    $(this).addClass("group" + groupNum);
    totalBlocks = parseInt($(this).attr("last-block-number"));
    if ((index + 1) % 5 === 0) {
      groupNum++;
    }
  });
  $('.PRS .loadmore-reviews').on('click', function(e){
    e.preventDefault();
    $(".group" + currentGroupNum).show();
    totalNum += 5;
    console.log(totalBlocks);
    console.log(totalNum);
    if(totalBlocks == totalNum){
      $(this).hide();
    }
    currentGroupNum++;
  });
  setTimeout(() => {
    $('.PRS .loadmore-reviews').click();
  }, 1000);

  $(".PRS .product-review .review-desc").each(function(){
    let maxLength = 435;  
    let myStr = $(this).text();
    if($.trim(myStr).length > maxLength){
      let newStr = myStr.substring(0, maxLength);
      let removedStr = myStr.substring(maxLength, myStr.length);
      $(this).empty().html(newStr);
      $(this).append('<span class="read-more">... <span class="read-more-text">read more</span></span>');
      $(this).append('<span class="more-text">'+removedStr+'</span>');
    }
  });
  $(".PRS .product-review .review-desc .read-more").click(function(){
    $(this).siblings(".more-text").contents().unwrap();
    $(this).remove();
  });
  // faqs
  $(".FAQS .faq .s-faq .qstn").click(function() {
      $(this).siblings(".ans").slideToggle();
      $(this).find(".minus").toggle();
      $(this).find(".plus").toggle();
  });

  // all product quick add popup qty selector
  let qtyNum = 1;
  $(".quick-add-popup .qty-selector .qty-box").text(qtyNum);
  $(".quick-add-popup .qty-selector .minus-icon").click(function (e) { 
    e.preventDefault();
    if(qtyNum > 1){
      qtyNum--;
      $(".quick-add-popup .qty-selector .qty-box").text(qtyNum);
    }
  });
  $(".quick-add-popup .qty-selector .plus-icon").click(function (e) { 
    e.preventDefault();
    qtyNum++;
    $(".quick-add-popup .qty-selector .qty-box").text(qtyNum);
  });

  // add to cart - collection page product quick add popup
  $(".quick-add-popup .variant-options .option-variant-input").first().click();
  $(".quick-add-popup .add-to-cart-btn-in-modal .atc-btn").click(function (e) { 
    e.preventDefault();
    let activeVariantId = null;
    let qtyValue = null;
    let selling_plan_id = $(this).attr("selling-plan-id");
    $(this).parents(".qty-selector-with-atc").siblings(".variant-options").children(".varint-opt-box").each(function(){
      if($(this).children(".option-variant-input").is(":checked")){
        activeVariantId = $(this).children(".option-variant-input").val();
        console.log(activeVariantId);
      }
    });
    // $(this).attr("variant-id");
    qtyValue = parseInt($(this).parents(".add-to-cart-btn-in-modal").siblings(".qty-selector").find(".qty-box").text());
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        id: activeVariantId,
        quantity: qtyValue,
        selling_plan: selling_plan_id
      },
      dataType: "json",
      success: function(data) {
        console.log(data.id);
        
      },
      error: function(data){
        console.log(data);
      }
    });
  });

  // header menu
  $(document).mouseup(function(e){
    var container = $("#menu-drawer");
    if (!container.is(e.target) && container.has(e.target).length === 0){
      $("#menu-drawer .menu-drawer-add-open summary.menu-drawer__menu-item").removeClass("mobile-submene-opened");
      $("#menu-drawer .menu-drawer-add-open summary.menu-drawer__menu-item").addClass("up-arrow");
      $("#menu-drawer .menu-drawer__submenu").slideUp();
    }
  });
  $(".close-icon .icon.icon-close").click(function(){
    $(".header__icon .icon-close").click();
    $("#menu-drawer .menu-drawer-add-open summary.menu-drawer__menu-item").removeClass("mobile-submene-opened");
    $("#menu-drawer .menu-drawer-add-open summary.menu-drawer__menu-item").addClass("up-arrow");
    $("#menu-drawer .menu-drawer__submenu").slideUp();
  });
  $("#menu-drawer .menu-drawer-add-open summary.menu-drawer__menu-item").click(function(event){
    event.preventDefault();
    $("#menu-drawer .menu-drawer-add-open summary.menu-drawer__menu-item").attr('open', '');
    $(this).toggleClass("up-arrow");
    $(this).toggleClass("mobile-submene-opened");
    $("#menu-drawer .menu-drawer__submenu").slideToggle();
  });

  // cart items
  function setQuantityToOne() {
    // Fetch the current cart
    $.ajax({
      type: 'GET',
      url: '/cart.js', // Shopify's cart API endpoint
      dataType: 'json',
      success: function(cart) {
        // Modify the quantity for each item
        $.each(cart.items, function(index, item) {
          // Update the quantity to 1
          console.log(item);
          if(item.handle.includes("trial")) updateCartItemQuantity(item.key, 1);
        });
      },
      error: function(err) {
        console.error('Error fetching cart:', err);
      }
    });
    setTimeout(() => {
      $(".cart-items-to-load").load(" .cart-items-to-load");
      $(".cart-footer-to-load").load(" .cart-footer-to-load");
      $(".header__cart-count").load(" .header__cart-count");
    }, 2000);
  }

  function updateCartItemQuantity(itemKey, newQuantity) {
    $.ajax({
      type: 'POST',
      url: '/cart/update.js', // Shopify's cart update API endpoint
      data: {
        updates: {
          [itemKey]: newQuantity
        }
      },
      dataType: 'json',
      success: function(updatedCart) {
        console.log('Item updated successfully:', updatedCart);
      },
      error: function(err) {
        console.error('Error updating item:', err);
      }
    });
  }
  setQuantityToOne();

  // hover on product media
  $(".product-template-wrapper .product__media-wrapper .product__media-list .product__media-item").hover(function () {
      // over
      $(this).find(".plus-icon-on-hover").css('display', 'flex');
    }, function () {
      // out
      $(this).find(".plus-icon-on-hover").css('display', 'none');
    }
  );

  // product page accordion
  var isOpened = null;
  $(".product__accordion-wrapper").each(function(){
    isOpened = $(this).find("details").attr('opened');
    if(isOpened !== undefined){
      $(this).find("details").attr('opened',  '');
      $(this).find(".accordion__content").slideDown();
    }else{
      $(this).find("details").removeAttr('opened');
      $(this).find(".accordion__content").slideUp();
    }
  })
  $(".product__accordion-wrapper .product__accordion.accordion summary").click(function(e){
    e.preventDefault();
    $(".product__accordion-wrapper .product__accordion.accordion details").not($(this).parents("details")).removeAttr('opened');
    $(".product__accordion-wrapper .product__accordion.accordion .accordion__content").not($(this).siblings(".accordion__content")).slideUp();
    isOpened = $(this).parents("details").attr('opened');
    if(isOpened === undefined){
      $(this).parents("details").attr('opened',  '');
      $(this).siblings(".accordion__content").slideDown();
    }else{
      $(this).parents("details").removeAttr('opened');
      $(this).siblings(".accordion__content").slideUp();
    }
  });

  // BFS learn more
  $(".FBS .learn-more-btn").click(function (e) { 
    e.preventDefault();
    $(this).parents(".learn-more-btns").siblings(".learn-more-desc").slideToggle();
  });


  // add bundles to cart - test script
  $(".add-bundle-to-cart").click(function (e) { 
    e.preventDefault();
    let bundleID = $(this).attr("bundle-id");
    let sellingPlan = $(this).attr("selling-plan");
    data = {
      "id": bundleID,
      "quantity": 1,
      "selling_plan": sellingPlan,
      "properties": {
        "Contents": "2x Strong (5)"
      }
    }
    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function(data) {
          console.log(data.id);
          
      },
      error: function(data) {
          console.error("Error:", data.statusText);
      }
    });
  });
  $('#BT5 a.section-scroll-btn[href^="#"]').on('click', function(event) {
    var target = $(this.getAttribute('href'));
    if(target.length) {
      event.preventDefault();
      $('html, body').stop().animate({
        scrollTop: target.offset().top
      }, 1000);
    }
  });
  
  // custom AJAX call
  $("#BT5 .enable_atc_custom_ajax").click(function (e) { 
    e.preventDefault();
    let selling_plan_id = $(this).attr('selling-plan-id');
    let productId = $(this).attr('product-id');
    $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
          id: productId,
          quantity: 1,
          selling_plan: selling_plan_id
        },
        dataType: "json",
        success: function(data) {
          console.log(data.id);
        },
        error: function(data){
          console.log(data);
        }
      });
  });

  console.log("PLay");
  $(".NVB .background-video-desktop").attr('autoplay', 'true');


  
  // video slider - New Landing page
  if (typeof $.fn.slick === 'function') {
    $('#BT5 .KSS-NL .videos-slider').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: '.prev_arrow',
      nextArrow: '.next_arrow',
      cssEase: 'ease',
      responsive: [
        {
          breakpoint: 1080,
          settings: {
            cssEase: 'ease',
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: false
          }
        },
        {
          breakpoint: 768,
          settings: {
            cssEase: 'ease',
            slidesToScroll: 1,
            arrows: false,
            variableWidth: true
          }
        }
      ]
    });
  }

  // slick slider
  $("#BT5 .KSS-NL .videos-slider .video-slide .play-button").on("click", function () {
    $("#BT5 .KSS-NL .videos-slider .video-slide video").each(function(){
      $(this).get(0).pause();
      $("#BT5 .KSS-NL .videos-slider .video-slide .play-button").show();
    });
    $(this).siblings("video")[0].play();
    $(this).hide();
  });
  // Optional: Pause the video when it ends
  $("#BT5 .KSS-NL .videos-slider .video-slide video").on("click", function (){
    $(this).siblings(".play-button").show();
    $(this).get(0).pause();
  });

  let OriginalPrice = parseInt($("#BT5 .PDS-NL .price-nl").attr('price-value'));
  let CompareAtPricePrice = parseInt($("#BT5 .PDS-NL .price-nl").attr('compare-at-price-value'));
  if(OriginalPrice > 0 && CompareAtPricePrice > 0){
    $("#BT5 .PDS-NL .price-nl .save-badge .save-badge-text").text(CompareAtPricePrice - OriginalPrice)
  }else{
    $("#BT5 .PDS-NL .price-nl .save-badge").hide();
  }

  
  $("#BT5 .PDS-NL .btn-nl-styles").click(function (e) { 
    e.preventDefault();
    let selling_plan_id = $(this).attr('selling-plan-id');
    let productId = $(this).attr('product-id');
    $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
          id: productId,
          quantity: 1,
          selling_plan: selling_plan_id
        },
        dataType: "json",
        success: function(data) {
          console.log(data.id);
        },
        error: function(data){
          console.log(data);
        }
      });
  });

  $("#BT5 .KXL-PDP .block-type-subs-btn").click(function(e){
    e.preventDefault();
    $("#BT5 .KXL-PDP .block-wrapper-subs").removeClass("selected");
    $(this).parents(".block-wrapper-subs").addClass("selected");
    $("#BT5 .KXL-PDP .atc-btn").click();
  });

  $("#BT5 .KXL-PDP .block-type-one-time-btn").click(function(e){
    e.preventDefault();
    $("#BT5 .KXL-PDP .block-wrapper-subs").removeClass("selected");
    $(this).parents(".block-wrapper-subs").addClass("selected");
    $("#BT5 .KXL-PDP .atc-btn").click();
  });

  $("#BT5 .KXL-PDP .block-type-one-time-btn-wrapper").click(function(e){
    e.preventDefault();
    $(this).find(".block-type-one-time-btn").not(e.target).toggle();
  });

  // product reviews page script
  let reviewsPageArticles = $('.PRNS .product-review');
  let reviewsPerPage = 50;
  let currentVisibleCount = 0;

  // Hide all reviews initially
  reviewsPageArticles.hide();
  
  // Hide all "Load More" buttons except the last one
  $('.PRNS .loadmore-reviews').last().show();

  // Function to show next 50 reviews
  function showNextReviews() {
    let nextCount = currentVisibleCount + reviewsPerPage;
    reviewsPageArticles.slice(currentVisibleCount, nextCount).fadeIn();
    currentVisibleCount = nextCount;

    // Hide the last "Load More" button if all reviews are shown
    if (currentVisibleCount >= reviewsPageArticles.length) {
      $('.PRNS .loadmore-reviews').last().hide();
    }
  }
  // Show first 50 reviews initially
  showNextReviews();

  // Load more reviews on click
  $('.PRNS .loadmore-reviews').last().on('click', function (e) {
    e.preventDefault();
    showNextReviews();
  });

  // Truncate long reviews
  $(".PRNS .product-review .review-desc").each(function () {
    let maxLength = 435;
    let myStr = $(this).text().trim();

    if (myStr.length > maxLength) {
      let newStr = myStr.substring(0, maxLength);
      let removedStr = myStr.substring(maxLength);
      $(this).html(`
        ${newStr}
        <span class="read-more">... <span class="read-more-text">read more</span></span>
        <span class="more-text" style="display:none;">${removedStr}</span>
      `);
    }
  });

  // Expand full review on "read more" click
  $(".PRNS").on("click", ".review-desc .read-more", function () {
    $(this).siblings(".more-text").fadeIn();
    $(this).remove();
  });

  // Collect all unique product handles from reviews
  let uniqueProductsInReviews = [];

  reviewsPageArticles.each((_, review) => {
    const productHandle = $(review).attr('product-handle');
    if (productHandle && !uniqueProductsInReviews.includes(productHandle)) {
      uniqueProductsInReviews.push(productHandle);
    }
  });

  // Async function to fetch product details by handle
  async function getProductByHandle(handle) {
    const res = await fetch(`/products/${handle}.json`);
    const data = await res.json();
    return data.product || 'Not found';
  }

  // Populate product dropdown with product titles
  (async () => {
    for (const productHandle of uniqueProductsInReviews) {
      const productDetails = await getProductByHandle(productHandle);
      $(".PRNS .review-filter-form .products-select-box").append(`
        <option value="${productDetails.id}">${productDetails.title}</option>
      `);
    }
  })();

  // Handle form submission for filtering
  $(".PRNS .review-filter-form").on("submit", function (e) {
    e.preventDefault();

    // Default filter values
    let selectedRating = "all";
    let selectedProduct = "all";

    // Get rating value only if the dropdown exists
    const ratingSelect = $(this).find('.ratings-select-box').eq(0);
    if (ratingSelect.length > 0) {
      selectedRating = ratingSelect.val() || "all";
    }

    // Get product value
    const productSelect = $(this).find('.products-select-box');
    if (productSelect.length > 0) {
      selectedProduct = productSelect.val() || "all";
    }

    let visibleCount = 0;

    console.log(`Rating: ${selectedRating}, Product: ${selectedProduct}`);

    // Loop through all reviews
    $(".PRNS .product-review").each(function () {
      const review = $(this);
      const reviewRating = parseFloat(review.attr("star-rating"));
      const reviewProductId = review.attr("product-id");

      let show = true;

      // Product filter
      if (selectedProduct !== "all" && reviewProductId !== selectedProduct) {
        show = false;
      }

      // Rating filter (skip if "all" or dropdown missing)
      if (selectedRating !== "all") {
        const ratingValue = parseInt(selectedRating);
        if (reviewRating < ratingValue || reviewRating > ratingValue + 0.5) {
          show = false;
        }
      }

      review.toggle(show);
      if (show) visibleCount++;
    });

    // Handle "no reviews" message
    if ($(".PRNS #no-reviews-msg").length === 0) {
      $(".review-filter-form").after(`
        <p id="no-reviews-msg" class="text-center mt-3" style="display:none; color:#868686;">
          No reviews found for the selected filters.
        </p>
      `);
    }

    $('.PRNS .loadmore-reviews').hide();

    if (visibleCount === 0) {
      $(".PRNS #no-reviews-msg").first().fadeIn();
    } else {
      $(".PRNS #no-reviews-msg").hide();
    }
  });



});
